module.exports = __webpack_public_path__ + "static/media/2012 - 13 Olivia Choi-min.2875808b.jpg";